import axios from 'axios';
import { IUserInfo } from '../interfaces';

const USERS_BASE_URL = process.env.REACT_APP_USERS_BASE_URL;
const CONSULTANT_BASE_URL = process.env.REACT_APP_CONSULTANT_BASE_URL;

const getUserInfo = async (token: string): Promise<IUserInfo> => {
  const response = await axios.get(`${USERS_BASE_URL}authentication/decode-user-info/${token}`);

  return response.data;
};

const updatePassword = async (userInfo: IUserInfo): Promise<number> => {
  const response = await axios.put(
    `${USERS_BASE_URL}authentication/update-password`,
    {
      userInfo,
    },
    {
      headers: { authorization: userInfo.token },
    }
  );

  return response.data.chagedRows;
};

const registerUserForConsultant = async (token: string): Promise<number> => {
  const response = await axios.post(`${CONSULTANT_BASE_URL}customer/register`, {
    token,
  });

  return response.data;
};

export const apiAuth = {
  getUserInfo,
  updatePassword,
  registerUserForConsultant,
};
